import * as API from '@siloreal:shared:api';

const SILOBAG_CERTIFICATE_ENDPOINT = '/cmcs';

export type GenerateSilobagCertificateServiceContract = {
  query: string | number;
  signal?: AbortSignal;
};

export type GenerateSilobagCertificateResponse = {
  file_path: string;
  certificate_url: string;
};

export async function generateSilobagCertificateService(
  contract: GenerateSilobagCertificateServiceContract
): Promise<GenerateSilobagCertificateResponse> {
  const silobagId = encodeURIComponent(String(contract.query));
  const query = `/${silobagId}?blockchain=true&silobagHistory=true`;
  const { data } = await API.http.fetch.post<GenerateSilobagCertificateResponse>(
    SILOBAG_CERTIFICATE_ENDPOINT,
    {
      query,
      signal: contract.signal,
    }
  );

  return data;
}
